import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';
import { simradTrace } from '../utils/simrad-trace.util';

/** Segmento da rota filha do layout (`/desenvolvimento`). */
export const RECURSO_EM_DESENVOLVIMENTO_SEGMENT = 'desenvolvimento';

/** URL absoluta (mesmo segmento sob layout com path `''`). */
export const RECURSO_EM_DESENVOLVIMENTO_PATH =
  '/' + RECURSO_EM_DESENVOLVIMENTO_SEGMENT;

const DEFAULT_TITULO = 'Funcionalidade';

export function createRecursoEmDesenvolvimentoUrlTree(
  router: Router,
  titulo: string = DEFAULT_TITULO,
): UrlTree {
  const tree = router.parseUrl(RECURSO_EM_DESENVOLVIMENTO_PATH);
  tree.queryParams['titulo'] = titulo.trim() || DEFAULT_TITULO;
  return tree;
}

/**
 * Coloque este guard **depois** de `AuthGuard` / `RoleGuard` quando aplicável.
 * Se `route.data.recursoEmDesenvolvimento === true`, não carrega a rota e envia para a página genérica,
 * salvo quando a feature flag do ambiente permite o fluxo real.
 */
export const recursoEmDesenvolvimentoGuard: CanActivateFn = (route) => {
  if (route.data['recursoEmDesenvolvimento'] !== true) {
    return true;
  }

  const routePath = route.routeConfig?.path ?? route.url.map((s) => s.path).join('/');

  if (
    route.data['recursoEmDesenvolvimentoUnlessEquipamentosFeature'] === true &&
    environment.features.equipamentos
  ) {
    simradTrace('RecursoEmDesenvolvimento', 'rota liberada (feature equipamentos)', {
      path: routePath,
      featuresEquipamentos: environment.features.equipamentos,
    });
    return true;
  }

  if (
    route.data['recursoEmDesenvolvimentoUnlessPacientesFeature'] === true &&
    environment.features.pacientes
  ) {
    simradTrace('RecursoEmDesenvolvimento', 'rota liberada (feature pacientes)', {
      path: routePath,
      featuresPacientes: environment.features.pacientes,
    });
    return true;
  }

  const router = inject(Router);
  const raw = route.data['recursoEmDesenvolvimentoTitulo'];
  const titulo =
    typeof raw === 'string' && raw.trim().length > 0 ? raw.trim() : DEFAULT_TITULO;

  simradTrace('RecursoEmDesenvolvimento', 'redirecionando para /desenvolvimento', {
    path: routePath,
    titulo,
    featuresEquipamentos: environment.features.equipamentos,
    featuresPacientes: environment.features.pacientes,
    unlessEquipamentos: route.data['recursoEmDesenvolvimentoUnlessEquipamentosFeature'] === true,
    unlessPacientes: route.data['recursoEmDesenvolvimentoUnlessPacientesFeature'] === true,
  });

  return createRecursoEmDesenvolvimentoUrlTree(router, titulo);
};
